import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Building2, Shield, Users, Home, FileText, Globe, ArrowRight } from 'lucide-react';
import { PracticeArea } from '../types';

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  Building2, Shield, Users, Home, FileText, Globe,
};

export default function PracticeAreaCard({ area, index }: { area: PracticeArea; index: number }) {
  const Icon = iconMap[area.icon] || Building2;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ delay: index * 0.1, duration: 0.5 }}
    >
      <Link
        to={`/practice-areas/${area.slug}`}
        className="group block p-8 rounded-2xl bg-gradient-to-b from-[#0f2240]/60 to-[#0a1628]/60 border border-[#c9a84c]/10 hover:border-[#c9a84c]/30 hover:shadow-2xl hover:shadow-[#c9a84c]/5 transition-all duration-500 relative overflow-hidden"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#c9a84c]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        <div className="relative z-10">
          <div className="w-14 h-14 rounded-xl bg-[#c9a84c]/10 flex items-center justify-center mb-6 group-hover:bg-[#c9a84c]/20 group-hover:scale-110 transition-all duration-300">
            <Icon className="w-7 h-7 text-[#c9a84c]" />
          </div>
          <h3 className="text-xl font-bold text-[#e8e4dc] mb-3 group-hover:text-[#c9a84c] transition-colors" style={{ fontFamily: 'Playfair Display, serif' }}>
            {area.title}
          </h3>
          <p className="text-sm text-[#e8e4dc]/60 leading-relaxed mb-6">{area.description}</p>
          <div className="flex items-center gap-2 text-sm text-[#c9a84c] font-medium opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300">
            <span>View Case Studies</span>
            <ArrowRight className="w-4 h-4" />
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
